import React from 'react'
import LoginSection from './PharmaLabLoginSection/LoginSection';
import CommonTemplate from '../../Template/CommonTemplate';
import './LoginPage.css'

function PharmaLabLogin() {
  
    React.useEffect(() => {
      window.scrollTo(0, 0)
    }, [])
    return (
        <>
            <CommonTemplate>
                <LoginSection />
            </CommonTemplate>

        </>
    )

}

export default PharmaLabLogin;